const PACKAGE_VERSION = "1.4.0";
const TARGETED_RPC_VERSION = "1.31.0";
export {
  PACKAGE_VERSION,
  TARGETED_RPC_VERSION
};
//# sourceMappingURL=version.js.map
